export default "__VITE_ASSET__bad97751__"